// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NqNO","icon":"styles_icon__2jyS3"};